export default __webpack_public_path__ + "d9ea3688c59dd1e22f84b376cb503737.svg";